import type { ComponentType } from "react";
import { AlertTriangle, Bell, CalendarDays, Clock, Wallet } from "lucide-react";
import { reais } from "@/lib/dinheiro";
import { cn } from "@/lib/cn";
import type { Atencao } from "./painel";

const SINAIS: { chave: Atencao; rotulo: string; icone: ComponentType<{ className?: string }>; cor: string; dinheiro?: boolean }[] = [
  { chave: "atrasados", rotulo: "Pedidos atrasados", icone: AlertTriangle, cor: "text-red-600" },
  { chave: "aceite", rotulo: "Aguardando aceite", icone: Clock, cor: "text-amber-600" },
  { chave: "hoje", rotulo: "Consultas hoje", icone: CalendarDays, cor: "text-zinc-900 dark:text-foreground" },
  { chave: "vencido", rotulo: "Vencido nas cobranças", icone: Wallet, cor: "text-red-600", dinheiro: true },
  { chave: "naoLidas", rotulo: "Não lidas", icone: Bell, cor: "text-zinc-900 dark:text-foreground" },
];

/** "Pede atenção agora": a soma de todas as organizações. Clicar filtra a tabela para quem tem. */
export function FaixaDeAtencao({ totais, filtro, onFiltrar }: { totais: Record<Atencao, number>; filtro: Atencao | null; onFiltrar: (a: Atencao | null) => void }) {
  return (
    <section data-tour="organizacoes-visao-geral" aria-label="Pede atenção agora" className="space-y-2">
      <p className="text-xs font-semibold uppercase tracking-wider text-zinc-500 dark:text-muted-foreground">Pede atenção agora</p>
      <div className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] sm:mx-0 sm:grid sm:grid-cols-5 sm:gap-3 sm:overflow-visible sm:px-0 [&::-webkit-scrollbar]:hidden">
        {SINAIS.map((s) => {
          const valor = totais[s.chave];
          const marcado = filtro === s.chave;
          const Icone = s.icone;
          return (
            <button
              key={s.chave}
              type="button"
              aria-pressed={marcado}
              disabled={!valor && !marcado}
              onClick={() => onFiltrar(marcado ? null : s.chave)}
              className={cn(
                "flex min-w-[150px] shrink-0 items-center gap-3 rounded-xl border p-3 text-left shadow-sm transition-colors sm:min-w-0",
                marcado
                  ? "border-brand-600 bg-brand-50/60 ring-1 ring-brand-600 dark:border-primary dark:bg-primary/10 dark:ring-primary"
                  : "border-zinc-200 bg-white hover:border-zinc-300 disabled:cursor-default disabled:opacity-60 disabled:hover:border-zinc-200 dark:border-border dark:bg-card",
              )}
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-zinc-100 text-zinc-500 dark:bg-muted dark:text-muted-foreground">
                <Icone className="h-4 w-4" />
              </span>
              <span className="min-w-0">
                <span className={cn("block text-lg font-bold tabular-nums leading-tight", valor ? s.cor : "text-zinc-400")}>{s.dinheiro ? reais(valor) : valor}</span>
                <span className="block truncate text-[11px] text-zinc-500 dark:text-muted-foreground">{s.rotulo}</span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
